import { User } from 'lucide-react';
import type { MergeEntitySummary } from 'src/components/MergeTargetPicker';
import type { Client, MergeClient } from 'src/graphql';

export const CLIENT_ICON = <User size={16} />;

type SummarizableClient = MergeClient &
  Partial<Pick<Client, 'primaryEmail' | 'primaryPhoneNumber'>>;

export const toClientSummary = (client: SummarizableClient): MergeEntitySummary => ({
  id: client.clientId,
  title: client.fullName || [client.firstName, client.lastName].filter(Boolean).join(' '),
  secondary: client.primaryEmail ?? client.primaryPhoneNumber ?? undefined,
});
